import React, { useEffect, useRef, useState } from 'react';
import { 
  ArrowRight, 
  CheckCircle2, 
  // Calendar, 
  TrendingUp, 
  Car, 
  MapPin, 
  Disc, 
  AlertTriangle,
  Activity,
  Target,
  Route,
  Shield,
  Leaf,
  Zap,
  Navigation,
  Train,
  GitMerge,
  Layers,
  Sparkles,
  Award
} from 'lucide-react';
import '../styles/Prr-Project.css';


const HeroSection = ({ isKannada }) => {
  const heroSlides = [
    `${process.env.PUBLIC_URL}/prr-hero-background/prr-hero.png`,
    `${process.env.PUBLIC_URL}/prr-hero-background/prr-hero-2.png`,
    `${process.env.PUBLIC_URL}/prr-hero-background/prr-hero-3.png`,
    `${process.env.PUBLIC_URL}/prr-hero-background/prr-hero-4.png`,
  ];

  const handleExploreClick = () => {
    const target = document.getElementById('current-status-section');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="hero-section">
      <div className="hero-patterns">
        <div className="hero-bg-carousel">
          <div className="hero-bg-track">
            {[...heroSlides, ...heroSlides].map((slide, idx) => (
              <img
                key={`${slide}-${idx}`}
                src={slide}
                alt=""
                aria-hidden="true"
                className="hero-bg-slide"
                loading={idx < heroSlides.length ? 'eager' : 'lazy'}
                decoding="async"
              />
            ))}
          </div>
        </div>
        <div className="hero-pattern-grid"></div>
        <div className="hero-pattern-radial"></div>
        <div className="hero-watermark">PRR - 1</div>
      </div>

      <div className="hero-content">
        <div className="hero-title-group">
          <h1 className="hero-h1">{isKannada ? 'ಬೆಂಗಳೂರು' : 'Bengaluru'}</h1>
          <h1 className="hero-h1 faded">{isKannada ? 'ಬ್ಯುಸಿನೆಸ್' : 'Business'}</h1>
          <h1 className="hero-h1">{isKannada ? 'ಕಾರಿಡಾರ್' : 'Corridor'}</h1>
        </div>

        <div className="hero-info-row">
          <div className="hero-text-block">
            <h2 className="hero-subtitle">{isKannada ? 'ಪೆರಿಫೆರಲ್ ರಿಂಗ್ ರೋಡ್ - 1' : 'Peripheral Ring Road - 1'}</h2>
            <p className="hero-desc">
              {isKannada
                ? 'ಬೆಂಗಳೂರಿನ ಸಂಚಾರ ವ್ಯವಸ್ಥೆ ಮತ್ತು ನಗರ ಸಂಪರ್ಕದಲ್ಲಿ ಕ್ರಾಂತಿಕಾರಿ ಬದಲಾವಣೆ ತರಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ 68.364 ಕಿ.ಮೀ ಉದ್ದದ ಎಕ್ಸ್‌ಪ್ರೆಸ್‌ವೇ'
                : "A transformative 68.364 km expressway designed to revolutionize Bengaluru's traffic infrastructure and urban connectivity."}
            </p>
          </div>

          <button className="explore-btn" onClick={handleExploreClick}>
            <span>{isKannada ? 'ಯೋಜನೆ ವೀಕ್ಷಿಸಿ' : 'Explore Project'}</span>
            <ArrowRight className="icon-sm" />
          </button>
        </div>

        <div className="stats-row">
          <div className="stat-col">
            <div className="stat-val-group">
              <span className="stat-val">68.364</span>
              <span className="stat-unit">KM</span>
            </div>
              <span className="stat-label">{isKannada ? 'ಒಟ್ಟು ಉದ್ದ' : 'Total Length'}</span>
          </div>

          <div className="stat-col">
            <div className="stat-val-group">
              <span className="stat-val">80-100</span>
              <span className="stat-unit">KM/H</span>
            </div>
              <span className="stat-label">{isKannada ? 'ವೇಗದ ಮಿತಿ' : 'Design Speed'}</span>
          </div>

          <div className="stat-col">
            <div className="stat-val-group">
              <span className="stat-val">₹27,000</span>
              <span className="stat-unit">CR</span>
            </div>
              <span className="stat-label">{isKannada ? 'ಅಂದಾಜು ವೆಚ್ಚ' : 'Estimated Cost'}</span>
          </div>

        </div>
      </div>
    </div>
  );
};

const TimelineItem = ({ year, title, desc, italicDesc, isLeft, isActive }) => {
  const [isInView, setIsInView] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    if (!rowRef.current) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.35 }
    );
    observer.observe(rowRef.current);
    return () => observer.disconnect();
  }, []);

  const sideClass = isLeft ? 'slide-from-left' : 'slide-from-right';
  return (
    <div ref={rowRef} className={`timeline-row ${isInView ? 'in-view' : ''}`}>
      <div className={`timeline-col ${!isLeft ? 'hidden-content' : ''}`}>
        <div className={`timeline-card text-right ${sideClass} ${isActive ? 'active' : ''}`}>
          {isActive && isLeft && <div className="timeline-connector left-connector"></div>}
          <h3 className="tl-title">{title}</h3>
          <p className="tl-desc">{desc} {italicDesc}</p>
        </div>
      </div>

      <div className={`timeline-circle ${isActive ? 'active' : 'default'}`}>
        {isActive && <div className="timeline-ping"></div>}
        <span className="timeline-year-text">{year}</span>
      </div>

      <div className={`timeline-col ${isLeft ? 'hidden-content' : ''}`}>
        <div className={`timeline-card text-left ${sideClass} ${isActive ? 'active' : ''}`}>
          {isActive && !isLeft && <div className="timeline-connector right-connector"></div>}
          <h3 className="tl-title">{title}</h3>
          <p className="tl-desc">{desc} {italicDesc}</p>
        </div>
      </div>
    </div>
  );
};

const TimelineSection = ({ isKannada }) => {
  const timelineData = isKannada ? [
    { year: "1995", title: "ಪರಿಕಲ್ಪನೆ", desc: "PRR ಯೋಜನೆಯ ಪರಿಕಲ್ಪನೆ ರೂಪಿಸಿ, ಪ್ರಾಥಮಿಕ ಯೋಜನಾ ವರದಿಯನ್ನು ಸಿದ್ಧಪಡಿಸಲಾಯಿತು. ಇದು 1995ರ ಬೆಂಗಳೂರು ಸಮಗ್ರ ಅಭಿವೃದ್ಧಿ ಯೋಜನೆಯ (CDP) ಭಾಗವಾಗಿತ್ತು.", italicDesc: "ರಿಮೋಟ್ ಸೆನ್ಸಿಂಗ್ ಮತ್ತು GIS ತಂತ್ರಜ್ಞಾನ ಬಳಸಿ ಜಲವಿಜ್ಞಾನದ ಅಧ್ಯಯನ ಹಾಗೂ ರಸ್ತೆಯ ಹೊಂದಿಕೆಯನ್ನು ಸಿದ್ಧಪಡಿಸಲಾಯಿತು.", isLeft: true },
    { year: "2007-2008", title: "ಸಾಧ್ಯತಾ ಅಧ್ಯಯನಗಳು", desc: "ಕರಡು ಸಾಧ್ಯತಾ ವರದಿ, ತಾಂತ್ರಿಕ ವೇಳಾಪಟ್ಟಿಗಳು, ಸಂಚಾರ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಆರ್ಥಿಕ ಕಾರ್ಯಸಾಧ್ಯತಾ ವರದಿಯನ್ನು ಸಿದ್ಧಪಡಿಸಲಾಯಿತು.", italicDesc: "ಯೋಜನೆಯ ಯಶಸ್ಸನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಸಮಗ್ರ ಆರ್ಥಿಕ ಮತ್ತು ತಾಂತ್ರಿಕ ವಿಶ್ಲೇಷಣೆ ಪೂರ್ಣಗೊಳಿಸಲಾಯಿತು.", isLeft: false },
    { year: "2012-2013", title: "ಸ್ಥಳಾಕೃತಿ ಸಮೀಕ್ಷೆ", desc: "ಸ್ಥಳಾಕೃತಿ ಸಮೀಕ್ಷೆ ಮತ್ತು ಪ್ರಾಥಮಿಕ ಸಂಚಾರ ವರದಿಯನ್ನು ಸಿದ್ಧಪಡಿಸಲಾಯಿತು.", italicDesc: "ವಿವರವಾದ ಸಮೀಕ್ಷೆ ಮತ್ತು ಆರಂಭಿಕ ಸಂಚಾರ ಮೌಲ್ಯಮಾಪನಕ್ಕಾಗಿ ಪರಿಣಿತ ಸಲಹೆಗಾರರನ್ನು ನೇಮಿಸಲಾಯಿತು.", isLeft: true },
    { year: "2015", title: "ಪುನರ್ವಸತಿ ಯೋಜನೆ", desc: "ಅಂತಿಮ ಕರಡು ಪುನರ್ವಸತಿ ಕ್ರಿಯಾ ಯೋಜನೆಯನ್ನು ಸಲ್ಲಿಸಲಾಯಿತು.", italicDesc: "ಸ್ಥಳಾಂತರಗೊಳ್ಳುವವರ ಅಗತ್ಯತೆಗಳನ್ನು ಪೂರೈಸಲು ಸೂಕ್ತ ಕ್ರಮಗಳೊಂದಿಗೆ ಸಮಗ್ರ ಯೋಜನೆ ರೂಪಿಸಲಾಯಿತು.", isLeft: false },
    { year: "2018-2019", title: "ಸಂಚಾರ ವಿಶ್ಲೇಷಣೆ", desc: "ಮೂರನೇ ಬಾರಿಗೆ ಸಂಚಾರ ಸಮೀಕ್ಷೆ ಮತ್ತು ವಿಶ್ಲೇಷಣೆ ನಡೆಸಲಾಯಿತು. 2007, 2012 ಮತ್ತು 2019ರ ಸಮೀಕ್ಷೆಗಳನ್ನು ಹೋಲಿಸಲಾಯಿತು.", italicDesc: "ನಿರಂತರವಾಗಿ ಹೆಚ್ಚುತ್ತಿರುವ ಸಂಚಾರ ದಟ್ಟಣೆಯು ತುರ್ತು ಮೂಲಸೌಕರ್ಯ ಅಭಿವೃದ್ಧಿಯ ಅಗತ್ಯವನ್ನು ಎತ್ತಿ ತೋರಿಸಿತು.", isLeft: true },
    { year: "2023", title: "ಪರಿಸರ ಅನುಮೋದನೆ", desc: "ಪರಿಷ್ಕೃತ ಪರಿಸರ ಪ್ರಭಾವ ಮೌಲ್ಯಮಾಪನ (EIA) ವರದಿಯನ್ನು ಸಲ್ಲಿಸಿ ಅನುಮೋದನೆ ಪಡೆಯಲಾಯಿತು.", italicDesc: "ಪರಿಸರ ನಿಯಮಗಳ ಪಾಲನೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಂಡು ಅನುಮೋದನೆ ಪಡೆಯಲಾಯಿತು.", isLeft: false },
    { year: "2020-2025", title: "ಕರಡು ಡಿಪಿಆರ್", desc: "ತಾಂತ್ರಿಕ ಅವಶ್ಯಕತೆಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ, ಜುಲೈ 2025ರಲ್ಲಿ ಸಂಚಾರ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಮುನ್ಸೂಚನೆಗಳೊಂದಿಗೆ ಕರಡು DPR ಸಲ್ಲಿಸಲಾಯಿತು.", italicDesc: "ಸಮಗ್ರ ಸಂಚಾರ ಮುನ್ಸೂಚನೆಯ ಅಂತಿಮ ತಾಂತ್ರಿಕ ವರದಿ ಪೂರ್ಣಗೊಂಡಿತು.", isLeft: true },
    { year: "2026", title: "ಟೆಂಡರ್ ಪ್ರಕ್ರಿಯೆ", desc: "21.0 ಕಿ.ಮೀ ಉದ್ದದ ರಸ್ತೆ ನಿರ್ಮಾಣದ ಪ್ಯಾಕೇಜ್ 1 ಗಾಗಿ ಟೆಂಡರ್ ಕರೆಯಲಾಗಿದೆ.", italicDesc: "ಪ್ಯಾಕೇಜ್ 1 ರ ಟೆಂಡರ್‌ನೊಂದಿಗೆ ಯೋಜನೆ ಅನುಷ್ಠಾನದ ಹಂತಕ್ಕೆ ತಲುಪಿದೆ.", isLeft: false, isActive: true }
  ] : [
    { year: "1995", title: "Conceptualization", desc: "PRR was conceptualized and Preliminary Scheme Report was generated. PRR was a part of the Bengaluru CDP with a tentative alignment in 1995.", italicDesc: "Hydrological Studies and Alignment with Remote sensing and GIS was prepared.", isLeft: true },
    { year: "2007-2008", title: "Feasibility Studies", desc: "Draft Feasibility and Detailed Project Report Drawings, Technical Schedules, Traffic Analysis, Financial Viability Report were prepared.", italicDesc: "Comprehensive financial and technical analysis completed to ensure project viability.", isLeft: false },
    { year: "2012-2013", title: "Topographic Survey", desc: "Topographic Survey along with Preliminary Traffic Report was generated by External Consultant.", italicDesc: "External consultants brought in for detailed survey and initial traffic assessment.", isLeft: true },
    { year: "2015", title: "Resettlement Plan", desc: "Final Draft Resettlement Action Plan was submitted.", italicDesc: "Comprehensive plan to address resettlement requirements with proper action framework.", isLeft: false },
    { year: "2018-2019", title: "Traffic Analysis", desc: "Third Traffic Survey and Analysis performed. Comparison between three surveys (2007, 2012 & 2019) done and growth rates worked out.", italicDesc: "Detailed comparison showed consistent traffic growth patterns requiring urgent infrastructure development.", isLeft: true },
    { year: "2023", title: "Environmental Approval", desc: "Revised EIA was submitted and Approval accorded.", italicDesc: "Environmental Impact Assessment revised and approved ensuring ecological compliance.", isLeft: false },
    { year: "2020-2025", title: "Draft DPR", desc: "Numerous Technical requirements analysed and Draft DPR submitted on July 2025 including Traffic Analysis and projections.", italicDesc: "Final technical documentation completed with comprehensive traffic projections.", isLeft: true },
    { year: "2026", title: "Tender Floated", desc: "Tender for Package 1 for a length of 21.0 Kms is floated.", italicDesc: "Project moves into execution phase with Package 1 tender.", isLeft: false, isActive: true }
  ];

  return (
    <div id="current-status-section" className="timeline-section">
      <div className="status-badge">
        <CheckCircle2 className="icon-sm" />
        <span>{isKannada ? 'ಪ್ರಸ್ತುತ ಸ್ಥಿತಿ: ಪ್ಯಾಕೇಜ್ 1 ರ ಟೆಂಡರ್ ಕರೆಯಲಾಗಿದೆ.' : 'Current Status: Package 1 Tender Floated'}</span>
      </div>

      <p className="tl-subtitle">
        {isKannada
          ? 'ಅಭಿವೃದ್ಧಿ ಪಥ (1995 - 2026) - ಎರಡು ದಶಕಗಳ ಸುದೀರ್ಘ ಯೋಜನೆ ಮತ್ತು ಅಭಿವೃದ್ಧಿ'
          : 'Chronology of Events - Two Decades of Planning and Development'}
      </p>

      <div className="timeline-container">
        <div className="timeline-line"></div>
        {timelineData.map((item, index) => <TimelineItem key={index} {...item} />)}
      </div>
    </div>
  );
};

const ChallengeCard = ({ icon: Icon, stat, statUnit, label, title, desc, theme, source }) => {
  return (
    <div className={`challenge-card-wrapper theme-${theme}`}>
      <div className="challenge-card-glow"></div>
      
      <div className="challenge-card">
        <div className="card-icon-header">
          <div className="card-icon-box">
            <Icon className="icon-md" />
          </div>
        </div>
        
        <div className="card-stat-group">
          <div className="card-stat-row">
            <h3 className="card-stat">{stat}</h3>
            {statUnit && <span className="card-stat-unit">{statUnit}</span>}
          </div>
          <p className="card-label">{label}</p>
        </div>

        <h4 className="card-title">{title}</h4>
        <p className="card-desc">{desc}</p>

        {source && (
          <div className="card-source-box">
             <p className="card-source">- {source}</p>
          </div>
        )}

        <div className="card-bottom-border"></div>
      </div>
    </div>
  );
};

const ChallengesSection = ({ isKannada }) => {
  const cards = isKannada ? [
    { icon: TrendingUp, stat: "60%", statUnit: "+", label: "ಬೆಳವಣಿಗೆ", title: "ವೇಗದ ನಗರೀಕರಣ", desc: "2011-2024ರ ಅವಧಿಯಲ್ಲಿ ಬೆಂಗಳೂರು 60% ರಷ್ಟು ಬೆಳೆದಿದ್ದು, 741 ಚದರ ಕಿ.ಮೀ ವ್ಯಾಪಿಸಿದೆ. ಇದು ವೇಗದ ನಗರೀಕರಣಕ್ಕೆ ಕಾರಣವಾಗಿದೆ.", theme: "blue", source: "ಅಂಕಿಅಂಶಗಳ ಪ್ರಕಾರ" },
    { icon: Car, stat: "123", statUnit: "ಲಕ್ಷ", label: "ವಾಹನಗಳು", title: "ವಾಹನಗಳ ದಟ್ಟಣೆ", desc: "ನಗರದಲ್ಲಿ 123 ಲಕ್ಷ ವಾಹನಗಳಿದ್ದು, ರಸ್ತೆಗಳ ಸಾಮರ್ಥ್ಯದ ಮೇಲೆ ಭಾರಿ ಒತ್ತಡವಿದೆ. ವಾಹನಗಳ ಸಾಂದ್ರತೆಯಲ್ಲಿ ಸುಮಾರು 125% ಏರಿಕೆ ಕಂಡುಬಂದಿದೆ.", theme: "purple", source: "ಅಂಕಿಅಂಶಗಳ ಪ್ರಕಾರ" },
    { icon: AlertTriangle, stat: "ORR", label: "ಅವಲಂಬನೆ", title: "ರಿಂಗ್‌ ರೋಡ್‌ ಮೇಲೆ ಒತ್ತಡ", desc: "ಒಂದಾನೊಂದು ಕಾಲದಲ್ಲಿ ಬೈಪಾಸ್ ಆಗಿದ್ದ ಹೊರವರ್ತುಲ ರಸ್ತೆ (ORR), ಇಂದು ಕ್ಷಿಪ್ರ ಅಭಿವೃದ್ಧಿಯಿಂದ ಭಾರಿ ಸಂಚಾರ ದಟ್ಟಣೆಯನ್ನು ಎದುರಿಸುತ್ತಿದೆ.", theme: "orange-light" },
    { icon: Activity, stat: "ಅಧಿಕ", label: "ರೇಡಿಯಲ್ ಟ್ರಾಫಿಕ್ ಹೊರೆ", title: "ಹೆದ್ದಾರಿಗಳ ಸಂಯೋಜನೆ", desc: "ಹಲವು ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ರಾಜ್ಯ ಹೆದ್ದಾರಿಗಳು ORR ಗೆ ಸಂಧಿಸುವುದರಿಂದ ಪ್ರಮುಖ ಸ್ಥಳಗಳಲ್ಲಿ ದಟ್ಟಣೆ ಉಂಟಾಗುತ್ತಿದೆ.", theme: "teal" },
    { icon: Disc, stat: "ಸೀಮಿತ", label: "ಪರ್ಯಾಯಗಳು", title: "ನೈಸ್ ರಸ್ತೆಯ ಮೇಲಿನ ಹೊರೆ", desc: "ನೈಸ್ ರಸ್ತೆಯು ಪ್ರಮುಖ ಕಾರಿಡಾರ್‌ಗಳಿಗೆ ಆಸರೆಯಾಗಿದ್ದರೂ, ಹೆಚ್ಚುತ್ತಿರುವ ಸಂಚಾರದ ಬೇಡಿಕೆಯನ್ನು ನಿಭಾಯಿಸಲು ಅಸಮರ್ಪಕವಾಗಿದೆ.", theme: "indigo" },
    { icon: AlertTriangle, stat: "ಕ್ಲಿಷ್ಟಕರ", label: "ಯೋಜಿತವಲ್ಲದ ಅಭಿವೃದ್ಧಿ", title: "ಇಂಟರ್‌ಸೆಕ್ಷನ್‌ ದಟ್ಟಣೆ", desc: "ವೇಗವಾದ, ಯೋಜಿತವಲ್ಲದ ಅಭಿವೃದ್ಧಿಯಿಂದ ORR ಹಾಗೂ ಸಂಪರ್ಕ ರಸ್ತೆಗಳ ಪ್ರಮುಖ ಜಂಕ್ಷನ್‌ಗಳಲ್ಲಿ ತೀವ್ರ ದಟ್ಟಣೆ ಉಂಟಾಗಿದೆ.", theme: "orange-dark" }
  ] : [
    { icon: TrendingUp, stat: "60%", statUnit: "+", label: "GROWTH", title: "Rapid Urbanization", desc: "Bengaluru has grown by 60% (2011–2024), spreading across 741 sq. km with fast urbanization in peripheral areas.", theme: "blue", source: "Statistical data" },
    { icon: Car, stat: "123", statUnit: "L", label: "VEHICLES", title: "Vehicle Explosion", desc: "The city has 123 lakh vehicles, with ~125% growth in density, heavily straining road capacity.", theme: "purple", source: "Statistical data" },
    { icon: AlertTriangle, stat: "ORR", label: "DEPENDENCY", title: "Overburdened Ring Road", desc: "The Outer Ring Road (ORR), once a bypass, now faces heavy congestion due to rapid development along and beyond it.", theme: "orange-light" },
    { icon: Activity, stat: "High", label: "RADIAL TRAFFIC LOAD", title: "Highway Convergence", desc: "Multiple national and state highways funnel traffic into ORR, creating major bottlenecks.", theme: "teal" },
    { icon: Disc, stat: "Limited", label: "ALTERNATIVES", title: "NICE Road Load", desc: "The NICE Road supports key corridors but is insufficient to handle growing traffic demand.", theme: "indigo" },
    { icon: AlertTriangle, stat: "Critical", label: "UNPLANNED AND UNORGANISED", title: "Intersection Congestion", desc: "Rapid, unplanned development has led to severely congested junctions across ORR and connecting roads.", theme: "orange-dark" }
  ];

  return (
    <div className="challenges-section">
      <div className="section-pill">{isKannada ? 'ಸವಾಲುಗಳು' : 'The Challenge'}</div>
      <h2 className="section-h2">{isKannada ? 'ಪ್ರಸ್ತುತ ಸಂಚಾರ ದಟ್ಟಣೆಯ ಸ್ಥಿತಿಗತಿ' : 'Current Traffic Scenario'}</h2>
      <p className="section-sub">{isKannada ? 'ಬೆಂಗಳೂರು ಸಂಚಾರ ಮೂಲಸೌಕರ್ಯದ ಸವಾಲುಗಳ ಅರಿವು' : "Understanding Bengaluru's growing infrastructure challenges"}</p>

      <div className="challenges-grid">
        {cards.map((card, idx) => <ChallengeCard key={idx} {...card} />)}
      </div>

      <div className="teaser-wrapper">
        <div className="teaser-glow animate-pulse"></div>
        <div className="teaser-border">
          <div className="teaser-card">
             <div className="teaser-pill">
                 <span>✦</span> {isKannada ? 'ಪ್ರಮುಖ ಪರಿಹಾರ' : 'KEY SOLUTION'} <span>✦</span>
             </div>
             <h2 className="teaser-h2">{isKannada ? 'ಪೆರಿಫೆರಲ್‌ ರಿಂಗ್‌ ರೋಡ್- 1' : 'PRR-1 : The Key Solution'}</h2>
             <p className="teaser-p">
               {isKannada
                 ? 'ನಗರದೊಳಗೆ ಹೋಗುವ ಅಗತ್ಯವಿಲ್ಲದೇ ಸಾಗುವ ವೇಗದ ಮತ್ತು ವಿಶಾಲ ರಸ್ತೆಯನ್ನು ನಿರ್ಮಿಸುವ ಮೂಲಕ PRR ಮೇಲ್ಕಂಡ ಎಲ್ಲಾ ಸಮಸ್ಯೆಗಳಿಗೆ ನೇರ ಪರಿಹಾರ ನೀಡುತ್ತದೆ. ಇದು ಎಲ್ಲಾ ಮುಖ್ಯ ಹೆದ್ದಾರಿಗಳನ್ನು ಬೆಸೆಯುತ್ತದೆ ಮತ್ತು ಹೊರವಲಯದ ಪ್ರದೇಶಗಳಿಗೆ ಉತ್ತಮ ಸಂಪರ್ಕ ಕಲ್ಪಿಸುತ್ತದೆ.'
                 : 'The Peripheral Ring Road addresses these challenges head-on by creating a high-capacity, access-controlled corridor that bypasses the city center, connects all major highways, and provides seamless connectivity for the growing peripheral areas. This transformative infrastructure will reduce travel time, decrease congestion, and support sustainable urban development.'}
             </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ObjectivesSection = ({ isKannada }) => {
  const features = isKannada ? [
    { icon: Target, title: "ಕಾರ್ಯತಂತ್ರದ ಯೋಜನೆ", desc: "ಮುಂದಿನ ಬೆಳವಣಿಗೆಯನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು 2007ರಲ್ಲೇ ಯೋಜನೆ ರೂಪಿಸಲಾಗಿತ್ತು. 20 ವರ್ಷಗಳ ಟ್ರಾಫಿಕ್ ಅಂದಾಜಿನೊಂದಿಗೆ ಸಮೀಕ್ಷೆಗಳು ನಡೆದಿವೆ.", bg: "bg-blue" },
    { icon: Route, title: "ಸಂಚಾರ ಮರುಮಾರ್ಗ", desc: "ದೂರದ ವಾಹನಗಳು ಮತ್ತು ವಾಣಿಜ್ಯ ವಾಹನಗಳು ನಗರ ಕೇಂದ್ರ ಮತ್ತು ORR ಬಳಕೆ ಮಾಡದಂತೆ ಪರ್ಯಾಯ ಮಾರ್ಗ ಕಲ್ಪಿಸುವುದು ಉದ್ದೇಶ.", bg: "bg-green" },
    { icon: Shield, title: "ಭವಿಷ್ಯದ ಸಿದ್ಧ ಮೂಲಸೌಕರ್ಯ", desc: "ಮುಂದಿನ 20 ವರ್ಷಗಳ ಅಗತ್ಯಕ್ಕೆ ತಕ್ಕಂತೆ ರಸ್ತೆ ವಿನ್ಯಾಸಗೊಂಡಿದ್ದು, ಭವಿಷ್ಯದ ಬೇಡಿಕೆಗಳನ್ನು ನಿಭಾಯಿಸಲು ಸಿದ್ಧವಾಗಿದೆ.", bg: "bg-purple" },
    { icon: Leaf, title: "ಸುಸ್ಥಿರ ವಿನ್ಯಾಸ", desc: "ಗ್ರೀನ್ ಬೆಲ್ಟ್, ಮೆಟ್ರೋ ಜಾಗ, ಸೈಕಲ್ ಲೇನ್ ಮತ್ತು ಚರಂಡಿ ವ್ಯವಸ್ಥೆ ಸೇರಿದಂತೆ ಪರಿಸರ ಸ್ನೇಹಿ ವಿನ್ಯಾಸ.", bg: "bg-emerald" },
    { icon: Zap, title: "ಸ್ಮಾರ್ಟ್ ತಂತ್ರಜ್ಞಾನ", desc: "ಅತ್ಯಾಧುನಿಕ ITS ವ್ಯವಸ್ಥೆಯ ಮೂಲಕ ಸಂಚಾರದ ಸಮರ್ಥ ನಿರ್ವಹಣೆ.", bg: "bg-orange" },
    { icon: Navigation, title: "ನಿಯಂತ್ರಿತ ಪ್ರವೇಶ", desc: "ಮುಖ್ಯ ಜಂಕ್ಷನ್‌ಗಳಲ್ಲಿ ಮಾತ್ರ ಪ್ರವೇಶ/ನಿಗಮ, ಟೋಲ್ ಪ್ಲಾಜಾಗಳೊಂದಿಗೆ ಸರಾಗ ವಾಹನ ಚಲನೆ.", bg: "bg-red" }
  ] : [
    { icon: Target, title: "Strategic Planning", desc: "Proposed in 2007 anticipating future development. Traffic studies conducted 3 times with 20-year traffic forecast.", bg: "bg-blue" },
    { icon: Route, title: "Traffic Re-routing", desc: "Re-route all commercial and long-distance vehicles away from ORR and City Centre, reducing congestion significantly.", bg: "bg-green" },
    { icon: Shield, title: "Future-Ready Infrastructure", desc: "20-year design period for flexible pavement, ready for all future needs of the city with organized development.", bg: "bg-purple" },
    { icon: Leaf, title: "Sustainable Design", desc: "Green belt/Metro corridor provision along PRR length. Dedicated bicycle lanes and comprehensive drainage systems.", bg: "bg-emerald" },
    { icon: Zap, title: "Smart Technology", desc: "State-of-the-art Intelligent Transport System implementation for efficient traffic management.", bg: "bg-orange" },
    { icon: Navigation, title: "Controlled Access", desc: "Entry and exit regulated at major interchanges. Toll plazas at all grade separators ensuring smooth flow.", bg: "bg-red" }
  ];

  return (
    <div className="obj-section">
      <div className="section-pill">{isKannada ? 'ಪಿಆರ್‌ಆರ್ ಯೋಜನೆಯ ಪ್ರಮುಖ ಉದ್ದೇಶಗಳು ಮತ್ತು ಗುಣಲಕ್ಷಣಗಳು ' : 'Project Overview'}</div>


      <div className="obj-grid">
        {features.map((feature, idx) => {
          const Icon = feature.icon;
          return (
            <div key={idx} className="obj-card">
              <div className={`obj-icon-wrap ${feature.bg}`}>
                <Icon className="icon-md" strokeWidth={2} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TechnicalSpecsSection = ({ isKannada }) => {
  const specs = isKannada ? [
    { value: "100 ಮೀಟರ್", label: "ರಸ್ತೆಯ ಅಗಲ (Right of Way)" },
    { value: "8 ಪಥಗಳು", label: "ಮುಖ್ಯ ರಸ್ತೆ" },
    { value: "11 ಮೀಟರ್", label: "ಸರ್ವಿಸ್‌ ರಸ್ತೆ (ನಗರದ ಕಡೆ)" },
    { value: "7 ಮೀಟರ್", label: "ಸರ್ವಿಸ್‌ ರಸ್ತೆ (ನಗರದ ಹೊರವಲಯದ ಕಡೆ)" },
    { value: "4 ಮೀಟರ್", label: "ಸೆಂಟ್ರಲ್‌ ಮೀಡಿಯನ್‌" },
    { value: "2 ಮೀಟರ್", label: "ಸೈಕಲ್ ಲೇನ್" },
    { value: "35 ಮೀಟರ್", label: "ಮೂಲಸೌಕರ್ಯ ಅಭಿವೃದ್ಧಿ ವಲಯ" },
    { value: "21 ಕಿ.ಮೀ.", label: "ಪ್ಯಾಕೇಜ್‌-1ರ ಒಟ್ಟು ಉದ್ದ" }
  ] : [
    { value: "100m", label: "Right of Way" },
    { value: "8 Lanes", label: "Main Carriageway" },
    { value: "11m", label: "Service Road (City Side)" },
    { value: "7m", label: "Service Road (Outskirts)" },
    { value: "4m", label: "Central Median" },
    { value: "2m", label: "Bicycle Lane" },
    { value: "35m", label: "Infrastructure Development Space" },
    { value: "21 km", label: "Package 1 Total Length" }
  ];

  return (
    <div className="tech-section">
      <div className="tech-bg-glow"></div>
      <h2 className="section-h2 tech-title">{isKannada ? 'ತಾಂತ್ರಿಕ ವಿವರಗಳು' : 'Technical Specifications'}</h2>

      <div className="tech-grid">
        {specs.map((spec, idx) => (
          <div key={idx} className="tech-card">
            <span className="tech-val">{spec.value}</span>
            <span className="tech-label">{spec.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const CrossSectionView = ({ isKannada }) => (
  <div className="cs-section">
    <div className="cs-container">
      <h3 className="cs-title">{isKannada ? 'ಪಿಆರ್‌ಆರ್‌- 1 ರ ಕ್ರಾಸ್‌ ಸೆಕ್ಷನ್‌ ವಿವರಗಳು ಇಲ್ಲಿದೆ :' : 'The typical Cross section details is as below:'}</h3>
      <div className="cs-image-box">
        <img
          src={`${process.env.PUBLIC_URL}/PRR-IMAGES/prr-image.jpeg`}
          alt="PRR typical cross section"
          className="cs-image"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  </div>
);

const MajorStructuresSummary = ({ isKannada }) => (
  <div className="ms-section">
    <h2 className="ms-title">{isKannada ? 'ಪ್ಯಾಕೇಜ್ 1 ರ ಪ್ರಮುಖ ವಿವರಗಳು' : 'Major Structures'}</h2>
    <div className="ms-grid">
      {[
        {
          value: isKannada ? "10 ಸ್ಥಳಗಳು" : "10 locations",
          label: isKannada ? "ಮೇಲ್ಸೇತುವೆಗಳು / ಪ್ರಮುಖ ಜಂಕ್ಷನ್‌ಗಳು (Grade Separators/Interchanges)" : "Grade Separators/Interchanges"
        },
        {
          value: isKannada ? "5 ಸ್ಥಳಗಳು" : "5 locations",
          label: isKannada ? "ರೈಲ್ವೆ ಮೇಲ್ಸೇತುವೆಗಳು (ROB)" : "Railway Over Bridges (ROB)"
        },
        {
          value: isKannada ? "ಹಲವೆಡೆ" : "Multiple",
          label: isKannada ? "ವಾಹನಗಳ ಕೆಳಸೇತುವೆ ಮತ್ತು ಮೇಲ್ಸೇತುವೆಗಳು (Under Pass/Over Pass)" : "Vehicular Under Pass/Over Pass"
        },
        {
          value: isKannada ? "ಒಳಗೊಂಡಿದೆ" : "Included",
          label: isKannada ? "ಅರಣ್ಯ ಮತ್ತು ಜಲಮೂಲಗಳನ್ನು ದಾಟುವ ವ್ಯವಸ್ಥೆ (Crossings)" : "Forest & Water Body Crossings"
        }
      ].map((item, idx) => (
        <div key={idx} className="ms-card">
          <span className="ms-val">{item.value}</span>
          <span className="ms-label">{item.label}</span>
        </div>
      ))}
    </div>
    
    <div className="fac-container">
      <div className="fac-card">
        <h3 className="fac-title">{isKannada ? 'ಹೆಚ್ಚುವರಿ ಸೌಲಭ್ಯಗಳು' : 'Additional Facilities'}</h3>
        <div className="fac-grid">
           <div className="fac-item"><div className="fac-dot"></div><span className="fac-text">{isKannada ? 'ರಸ್ತೆಯ ಅಡ್ಡಲಾಗಿ ಮತ್ತು ಉದ್ದಕ್ಕೂ ನೀರು ಸರಾಗವಾಗಿ ಹರಿಯಲು ಚರಂಡಿಗಳ ನಿರ್ಮಾಣ.' : 'Cross drainage structures & longitudinal drains'}</span></div>
           <div className="fac-item"><div className="fac-dot"></div><span className="fac-text">{isKannada ? 'ರಸ್ತೆ ಸುರಕ್ಷತೆಯನ್ನು ಖಾತ್ರಿಪಡಿಸಲು ರಸ್ತೆ ಸೂಚನಾ ಫಲಕಗಳು, ಲೇನ್ ಗುರುತುಗಳು ಮತ್ತು ಅಪಘಾತ ತಡೆಯಲು ಸುರಕ್ಷತಾ ತಡೆಗೋಡೆಗಳು' : 'Road signs, lane markings & crash barriers'}</span></div>
           <div className="fac-item"><div className="fac-dot"></div><span className="fac-text">{isKannada ? 'ಭವಿಷ್ಯದಲ್ಲಿ ಪೈಪ್‌ಲೈನ್ ಅಥವಾ ಕೇಬಲ್‌ಗಳನ್ನು ಅಳವಡಿಸಲು ರಸ್ತೆಯ ಕೆಳಗೆ ಪ್ರತ್ಯೇಕ ಪಥಗಳು (ducts).' : 'Utility ducts and chambers for future crossings'}</span></div>
           <div className="fac-item"><div className="fac-dot"></div><span className="fac-text">{isKannada ? 'ರಸ್ತೆಯ ಅಕ್ಕಪಕ್ಕದಲ್ಲಿ ಗಿಡಮರಗಳನ್ನು ಬೆಳೆಸುವುದು ಮತ್ತು ಸುಂದರಗೊಳಿಸುವಿಕೆಯ ಮೂಲಕ ಹಸಿರೀಕರಣಕ್ಕೆ ಒತ್ತು' : 'Landscaping and arboriculture'}</span></div>
        </div>
      </div>
    </div>
  </div>
);

const PackageOneSalient = ({ isKannada }) => (
  <div className="pkg-section">
    <div className="pkg-header">
      <h2 className="pkg-title">{isKannada ? 'ಪ್ಯಾಕೇಜ್ 1 - ಪ್ರಮುಖ ಲಕ್ಷಣಗಳು' : 'Package 1 - Salient Features'}</h2>
    </div>
    <p className="pkg-subtitle">{isKannada ? 'ಕ್ರಾಂತಿಕಾರಿ ಯೋಜನೆಯ ಮೊದಲ ಹಂತ' : 'First Phase of the Transformative Project'}</p>

    <div className="fac-container">
       <div className="pkg-banner">
          <div className="pkg-content">
             <h3 className="pkg-banner-title">{isKannada ? 'ಪ್ಯಾಕೇಜ್ ವಿವರಗಳು' : 'Package Overview'}</h3>
             <div className="pkg-grid">
                <div className="pkg-stat-card">
                   <p className="pkg-stat-label">{isKannada ? 'ಪ್ಯಾಕೇಜ್ ಸಂಖ್ಯೆ' : 'Package Number'}</p><p className="pkg-stat-val">P1</p>
                </div>
                <div className="pkg-stat-card">
                   <p className="pkg-stat-label">{isKannada ? 'ಆರಂಭದ ಕಿಲೋಮೀಟರ್' : 'From Chainage'}</p><p className="pkg-stat-val">0.000</p>
                </div>
                <div className="pkg-stat-card">
                   <p className="pkg-stat-label">{isKannada ? 'ಅಂತ್ಯದ ಕಿಲೋಮೀಟರ್' : 'To Chainage'}</p><p className="pkg-stat-val">21,000</p>
                </div>
                <div className="pkg-stat-card">
                   <p className="pkg-stat-label">{isKannada ? 'ಕೇವಲ ಪಿಆರ್‌ಆರ್ ಉದ್ದ' : 'Only PRR'}</p><p className="pkg-stat-val">21,000</p>
                </div>
                <div className="pkg-stat-card lg-col-start-1">
                   <p className="pkg-stat-label">{isKannada ? 'ತುಮಕೂರು ಲಿಂಕ್ / ಹೊಸೂರು ಲಿಂಕ್' : 'Tumkur Link/ Hosur Link'}</p><p className="pkg-stat-val">0</p>
                </div>
                <div className="pkg-stat-card lg-col-start-2">
                   <p className="pkg-stat-label">{isKannada ? 'ಒಟ್ಟು ಮೊತ್ತ' : 'Grand Total'}</p><p className="pkg-stat-val">21,000</p>
                </div>
             </div>
          </div>
          <div className="pkg-footer">
             <p><span className="pkg-note-label">{isKannada ? 'ಗಮನಿಸಿ:' : 'Note:'}</span> {isKannada ? 'ಸಂಪೂರ್ಣ PRR-1 ಕಾರಿಡಾರ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಉಳಿದ ಪ್ಯಾಕೇಜ್‌ಗಳನ್ನು ಶೀಘ್ರದಲ್ಲೇ ಬಿಡುಗಡೆ ಮಾಡಲಾಗುವುದು.' : 'Additional packages shall be floated soon to complete the entire PRR-1 corridor.'}</p>
          </div>
       </div>
    </div>
  </div>
);

const DetailedMajorStructures = ({ isKannada }) => (
  <div className="ds-section">
    <div className="ds-image-container">
      <div className="ds-image-box">
        <img
          src={`${process.env.PUBLIC_URL}/PRR-IMAGES/PRR-IMAGE-2.png`}
          alt="PRR major structures visual"
          className="ds-image"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <div className="ds-grid">
      <h2 className="section-h2 section-h2-full-width">{isKannada ? 'ಪ್ಯಾಕೇಜ್ 1 ರ ಪ್ರಮುಖ ವಿವರಗಳು' : 'Major Structures'}</h2>
      
      <div className="struct-card">
        <div className="struct-icon-wrapper"><GitMerge className="icon-lg" /></div>
        <div>
           <div className="struct-title-row">{isKannada ? 'ಗ್ರೇಡ್ ಸಪರೇಟರ್ (ಮೇಲ್ಸೇತುವೆ)' : 'Grade Separator'} <span className="struct-subtitle">{isKannada ? '(1)' : '(1 No)'}</span></div>
           <p className="struct-desc-1">{isKannada ? 'ಹೆಸರಘಟ್ಟ ಜಂಕ್ಷನ್' : 'Hesarghatta Junction'}</p>
           <p className="struct-desc-2">{isKannada ? '0.71 ಕಿ.ಮೀ (ಏರು ಹಾಗೂ ತಗ್ಗು ರಸ್ತೆಗಳೂ ಸೇರಿ)' : '0.71 Kms (including approach and down ramps)'}</p>
        </div>
      </div>
      
      <div className="struct-card">
        <div className="struct-icon-wrapper"><Layers className="icon-lg" /></div>
        <div>
           <div className="struct-title-row">{isKannada ? 'ಫ್ಲೈಓವರ್‌ಗಳು / ಪ್ರಮುಖ ಸೇತುವೆಗಳು' : 'Flyover/Major Bridges'} <span className="struct-subtitle">{isKannada ? '(ಹಲವಾರು)' : '(Multiple Nos)'}</span></div>
           <p className="struct-desc-1">{isKannada ? 'ವಿವಿಧ ಸ್ಥಳಗಳು' : 'Various locations'}</p>
           <p className="struct-desc-2">{isKannada ? 'ಅಂದಾಜು 5.97 ಕಿ.ಮೀ' : 'Approx. 5.97 Kms'}</p>
        </div>
      </div>
      
      <div className="struct-card">
        <div className="struct-icon-wrapper"><MapPin className="icon-lg" /></div>
        <div>
           <div className="struct-title-row">{isKannada ? 'ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು' : 'Interchanges'} <span className="struct-subtitle">{isKannada ? '(3)' : '(3 Nos)'}</span></div>
           <p className="struct-desc-1">{isKannada ? 'ಮಾದಾವರ (ನೈಸ್ ರಸ್ತೆಯ ಸಂಯೋಜನೆ), ದೊಡ್ಡಬಳ್ಳಾಪುರ ಜಂಕ್ಷನ್, ಬಳ್ಳಾರಿ ರಸ್ತೆ (ಕಾಲಿನ್ಸ್ ಏರೋಸ್ಪೇಸ್ ಹತ್ತಿರ)' : 'Madavara (NICE Integration), Doddaballapura Junction, Bellary Road (Collins Aerospace)'}</p>
           <p className="struct-desc-2">{isKannada ? 'ಅಂದಾಜು 13 ಕಿ.ಮೀ (21 ಕಿ.ಮೀ ಮುಖ್ಯ ರಸ್ತೆಯ ಜೊತೆಗೆ ಹೆಚ್ಚುವರಿಯಾಗಿ)' : 'Approx. 13 Kms (additional to 21 km linear length)'}</p>
        </div>
      </div>
      
      <div className="struct-card">
        <div className="struct-icon-wrapper"><Train className="icon-lg" /></div>
        <div>
           <div className="struct-title-row">{isKannada ? 'ರೈಲ್ವೆ ಮೇಲ್ಸೇತುವೆಗಳು (ROB)' : 'Railway Over Bridges'} <span className="struct-subtitle">{isKannada ? '(3)' : '(3 Nos)'}</span></div>
           <p className="struct-desc-1">{isKannada ? 'ತುಮಕೂರು ರೈಲ್ವೆ ಲೈನ್ (ಹೆಸರಘಟ್ಟ), ದೊಡ್ಡಬಳ್ಳಾಪುರ ರೈಲ್ವೆ ಲೈನ್, ಚಿಕ್ಕಬಳ್ಳಾಪುರ ರೈಲ್ವೆ ಲೈನ್' : 'Tumkur Railway Line (Hesarghatta), Doddaballapura Railway Line, Chikkaballapura Railway Line'}</p>
           <p className="struct-desc-2">{isKannada ? 'ವಿವಿಧ ಸ್ಥಳಗಳಲ್ಲಿ' : 'Multiple locations'}</p>
        </div>
      </div>
    </div>
  </div>
);

const AdditionalStructures = ({ isKannada }) => (
  <div className="as-section">
    <div className="as-container">
      <h2 className="section-h2 section-h2-tight-margin">{isKannada ? 'ಇತರೆ ವಿನ್ಯಾಸಗಳು' : 'Additional Structures'}</h2>

      <div className="table-wrapper">
         <div className="table-header">
            <div className="col-1">{isKannada ? 'ವಿನ್ಯಾಸ' : 'Structure Type'}</div><div className="col-2">{isKannada ? 'ಸಂಖ್ಯೆ' : 'Count'}</div><div className="col-3">{isKannada ? 'ಉದ್ದ' : 'Length'}</div>
         </div>
         <div>
            {[
              [
                isKannada ? "ವಾಹನಗಳ ಕೆಳಸೇತುವೆ (VUP)" : "Vehicular Under Pass",
                "8",
                isKannada ? "4.50 ಕಿ.ಮೀ" : "4.50 Kms"
              ],
              [
                isKannada ? "ವಾಹನಗಳ ಮೇಲ್ಸೇತುವೆ (VOP)" : "Vehicular Over Pass",
                "2",
                isKannada ? "1.73 ಕಿ.ಮೀ" : "1.73 Kms"
              ],
              [isKannada ? "ಅರಣ್ಯ ಪ್ರದೇಶದ ಕ್ರಾಸಿಂಗ್" : "Forest Crossing", "1", "-"],
              [isKannada ? "ಕೆರೆ ಕ್ರಾಸಿಂಗ್‌" : "Lake Crossing", "1", "-"],
              [isKannada ? "ಟೋಲ್ ಕೇಂದ್ರಗಳು" : "Toll Locations", "6", "-"],
              [
                isKannada ? "ಸಾಮಾನ್ಯ ರಸ್ತೆ ವಿಭಾಗ" : "Normal Cross Section",
                "-",
                isKannada ? "8.09 ಕಿ.ಮೀ" : "8.09 Kms"
              ],
            ].map((row, idx) => (
              <div key={idx} className="table-row">
                <div className="col-1">{row[0]}</div><div className="col-2">{row[1]}</div><div className="col-3">{row[2]}</div>
              </div>
            ))}
         </div>
      </div>

      <div className="info-box">
         <h3 className="info-title">{isKannada ? 'ಮೂಲಸೌಕರ್ಯ ಅಭಿವೃದ್ಧಿ' : 'Infrastructure Development'}</h3>
         <p className="info-text">
            {isKannada
              ? 'ರಸ್ತೆಯ ವಿನ್ಯಾಸಕ್ಕೆ (horizontal alignment) ಅನುಗುಣವಾಗಿ ಅಗತ್ಯವಿರುವ ಕಡೆಗಳಲ್ಲಿ ಮೂಲಸೌಕರ್ಯ ಅಭಿವೃದ್ಧಿ ವಲಯಗಳನ್ನು ಯೋಜಿಸಲಾಗಿದೆ. ಈ ವಲಯಗಳಿಗಾಗಿ ಮೀಸಲಿಟ್ಟಿರುವ 35 ಮೀಟರ್ ಜಾಗದಲ್ಲಿ, ಭವಿಷ್ಯದ ಯುಟಿಲಿಟಿ ವಿಸ್ತರಣೆಗಳು, ಭೂಗತ ಕೇಬಲ್‌ಗಳು ಮತ್ತು ಇತರ ಅಗತ್ಯ ಸೇವೆಗಳಿಗೆ ಅವಕಾಶ ಕಲ್ಪಿಸಲಾಗುವುದು.'
              : 'Infrastructure development zones are planned where applicable based on the horizontal alignment of the roadway. These zones will accommodate future utility expansions, underground cables, and other essential services within the allocated 35m space.'}
         </p>
      </div>
    </div>
  </div>
);

const PathForwardSection = ({ isKannada }) => {
  const cards = isKannada ? [
    { icon: TrendingUp, title: "ತ್ವರಿತ ಬೆಳವಣಿಗೆ", desc: "ನಗರದ ವಾಹನಗಳ ಸಂಖ್ಯೆ ಪ್ರಸ್ತುತ 1.4 ಕೋಟಿಯಷ್ಟಿದ್ದು, ಮುಂದಿನ ಹತ್ತು ವರ್ಷಗಳಲ್ಲಿ ಇದು ದುಪ್ಪಟ್ಟಾಗುವ ಸಾಧ್ಯತೆ ಇದೆ.", bg: "bg-red" },
    { icon: MapPin, title: "ವ್ಯವಸ್ಥಿತ ಪರಿಹಾರ", desc: "PRR-1 17-25 ಕಿ.ಮೀ ದೂರದಲ್ಲಿ ನಿರ್ಮಾಣವಾಗಿ ವಾಣಿಜ್ಯ ವಾಹನಗಳಿಗೆ ಪರ್ಯಾಯ ಮಾರ್ಗ ಕಲ್ಪಿಸುತ್ತದೆ.", bg: "bg-blue" },
    { icon: Sparkles, title: "ವ್ಯವಸ್ಥಿತ ಅಭಿವೃದ್ಧಿ", desc: "ಮುಂದಿನ 10-20 ವರ್ಷಗಳ ಬೆಳವಣಿಗೆಯನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು ಯೋಜಿತ ಹೊರವಲಯ ಅಭಿವೃದ್ಧಿಯನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ.", bg: "bg-purple" },
    { icon: Award, title: "ನಗರದ ಪುನಶ್ಚೇತನ", desc: "PRR-1 ಬೆಂಗಳೂರಿನ ವೈಭವ ಮರುಸ್ಥಾಪಿಸಿ ತೀವ್ರ ಸಂಚಾರದ ನಗರ ಎಂಬ ಹಣೆಪಟ್ಟಿ ಕಡಿಮೆ ಮಾಡಲು ಸಹಕಾರಿಯಾಗಲಿದೆ.", bg: "bg-green" }
  ] : [
    { icon: TrendingUp, title: "Rapid Growth", desc: "Vehicle volume of 1.4 Crores expected to double within the next decade. All commercial and long-distance vehicles currently use ORR, creating severe congestion.", bg: "bg-red" },
    { icon: MapPin, title: "Strategic Solution", desc: "BBC (PRR-1) positioned 17-25 km from city centre will re-route commercial vehicles, eliminating the need to enter the city or use ORR.", bg: "bg-blue" },
    { icon: Sparkles, title: "Organized Development", desc: "Essential for anticipated 10-20 year growth. Prevents repetition of current ORR congestion and ensures planned development on city outskirts.", bg: "bg-purple" },
    { icon: Award, title: "City Revival", desc: "PRR-1 will restore Bengaluru's glory and remove the tag of being one of the world's most traffic congested cities.", bg: "bg-green" }
  ];

  return (
    <div className="pf-section">
      <h2 className="pf-title">{isKannada ? 'ಸಮೃದ್ಧ ಬೆಂಗಳೂರಿನ ಹಾದಿ' : 'The Path Forward for Bengaluru'}</h2>
      
      <div className="pf-grid">
        {cards.map((card, idx) => {
          const Icon = card.icon;
          return (
            <div key={idx} className="pf-card">
              <div className={`pf-icon-wrap ${card.bg}`}>
                <Icon className="icon-md pf-icon-white" />
              </div>
              <h3 className="pf-card-title">{card.title}</h3>
              <p className="pf-card-desc">{card.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="pf-banner-container">
        <div className="pf-banner">
          <h2 className="pf-banner-h2">{isKannada ? 'ಬೆಂಗಳೂರಿನ ಭವಿಷ್ಯಕ್ಕಾಗಿ ಹೂಡಿಕೆ' : "A Transformative Investment in Bengaluru's Future"}</h2>
          <p className="pf-banner-p">
            {isKannada
              ? 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ (PRR-1) ಕೇವಲ ಮೂಲಸೌಕರ್ಯ ಯೋಜನೆಯಲ್ಲ; ಇದು ಭಾರತದ ಸಿಲಿಕಾನ್ ವ್ಯಾಲಿಯನ್ನು ವಿಶ್ವದರ್ಜೆಯ ನಗರವನ್ನಾಗಿ ರೂಪಿಸುವ ದೃಷ್ಟಿಕೋನವಾಗಿದೆ.'
              : "The Bengaluru Business Corridor (PRR-1) represents more than just infrastructure—it's a strategic vision to transform India's Silicon Valley into a world-class city with organized growth, reduced congestion, and enhanced quality of life for millions."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default function App({ language = 'english' }) {
  const isKannada = language === 'kannada';
  return (
    <div className="app-root">
      <HeroSection isKannada={isKannada} />
      <TimelineSection isKannada={isKannada} />
      <ChallengesSection isKannada={isKannada} />
      <ObjectivesSection isKannada={isKannada} />
      <TechnicalSpecsSection isKannada={isKannada} />
      <CrossSectionView isKannada={isKannada} />
      <MajorStructuresSummary isKannada={isKannada} />
      <PackageOneSalient isKannada={isKannada} />
      <DetailedMajorStructures isKannada={isKannada} />
      <AdditionalStructures isKannada={isKannada} />
      <PathForwardSection isKannada={isKannada} />
    </div>
  );
}